import * as React from 'react';
import { useField } from 'react-final-form';

import Input from '../../BaseComponents/Input';
import { useTheme } from '../../theme';
import { useIsMobile } from '../../utils';

interface Props {
	name: string;
	label: string;
	validation?: (value: string) => string | void;
}

const Field: React.FC<Props> = ({ name, label, validation }) => {
	const { input, meta } = useField(name, {
		validate: (value: string) => (validation ? validation(value || '') : undefined),
		type: 'text'
	});

	const theme = useTheme('Forms').Field;
	const isMobile = useIsMobile();

	const hasError = ((meta.modified && meta.touched) || meta.submitFailed) && (!!meta.error || !!meta.submitError);

	return (
		<div className={theme.input__wrapper}>
			<Input
				{...input}
				label={label}
				variant={isMobile ? 'underline' : 'labelIn'}
				error={hasError}
				helperText={hasError ? meta.error || meta.submitError : undefined}
			/>
		</div>
	);
};

export default Field;
